import request from "./config";
export default class ReportService {
  static list(query = {}) {
    return request({
      url: "/report",
      method: "get",
      timeout: 10000,
      params: query,
    });
  }
  static searchDocument(query = {}) {
    return request({
      url: "/report/document-search",
      method: "get",
      timeout: 10000,
      params: query,
    });
  }
  static create(data){
    return request({
      url: "/report",
      method: "post",
      timeout: 100000,
      data,
    });
  }
  static changeStatus(data){
    return request({
      url: `/report/change-status/${data.id}`,
      method: "put",
      timeout: 100000,
      data,
    });
  }
  static delete(data){
    return request({
      url: `/report/delete/${data.id}`,// /api
      method: "delete",
      timeout: 100000,
    });
  }
  static update(id,data){
    return request({
      url: "/report/"+id,
      method: "put",
      timeout: 100000,
      data,
    });
  }
}
